import { render, staticRenderFns } from "./ListImg.vue?vue&type=template&id=2a518560&scoped=true"
import script from "./ListImg.vue?vue&type=script&lang=js"
export * from "./ListImg.vue?vue&type=script&lang=js"
import style0 from "./ListImg.vue?vue&type=style&index=0&id=2a518560&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a518560",
  null
  
)

export default component.exports